var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadVueTwo'),_c('router-view'),(_vm.showFooter)?_c('FooterVueTwo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }